import React, { useEffect, useRef, useState } from 'react';
import { GoogleMap as GoogleMapLib, Marker, useJsApiLoader } from '@react-google-maps/api';

// Stable references required by useJsApiLoader — must be outside component to prevent script reload on re-render
const LIBRARIES = ['geometry', 'drawing', 'places'];
const MAP_CONTAINER_STYLE = {
  width: '100%',
  height: '100%'
};
const MapWrapper = ({
  style,
  className,
  defaultCenter = {
    lat: 0,
    lng: 0
  },
  autocompleteRef = null,
  onMapClick = () => {},
  isMarkerShown = false,
  onPlaceSelected = () => {}
}) => {
  const {
    isLoaded
  } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_TOKEN,
    libraries: LIBRARIES
  });
  const geocoderRef = useRef(null);
  const [markerPosition, setMarkerPosition] = useState(null);
  const [markerVisible, setMarkerVisible] = useState(isMarkerShown);
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  useEffect(() => {
    setMarkerVisible(isMarkerShown);
  }, [isMarkerShown]);
  useEffect(() => {
    if (!isLoaded) return;
    geocoderRef.current = new window.google.maps.Geocoder();
  }, [isLoaded]);
  useEffect(() => {
    if (!isLoaded || !autocompleteRef?.current) return;
    const ac = new window.google.maps.places.Autocomplete(autocompleteRef.current, {
      types: ['geocode']
    });
    const listener = ac.addListener('place_changed', () => {
      const place = ac.getPlace();
      if (!place.geometry) return;
      const latLng = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      setMarkerPosition(latLng);
      setMapCenter(latLng);
      setMarkerVisible(true);
      onPlaceSelected(place);
    });
    return () => window.google.maps.event.removeListener(listener);
  }, [isLoaded, autocompleteRef]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleMapClick = e => {
    const latLng = e.latLng; // google.maps.LatLng object — preserves parseGoogleMapLocation interface
    setMarkerPosition({
      lat: latLng.lat(),
      lng: latLng.lng()
    });
    setMarkerVisible(true);
    if (!geocoderRef.current) return;
    geocoderRef.current.geocode({
      latLng
    }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
        onMapClick({
          position: latLng,
          address: results[0]
        });
      }
    });
  };
  if (!isLoaded) return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: className
  });
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(GoogleMapLib, {
    zoom: 16,
    center: mapCenter,
    onClick: handleMapClick,
    mapContainerStyle: MAP_CONTAINER_STYLE
  }, markerVisible && /*#__PURE__*/React.createElement(Marker, {
    position: markerPosition || defaultCenter
  })));
};
export { MapWrapper as GoogleMap };